import { useState, useEffect } from 'react'

interface UserRegion {
  countryCode: string
  currency: string
  isLoading: boolean
}

export function useUserRegion(): UserRegion {
  const [region, setRegion] = useState<UserRegion>({
    countryCode: 'US',
    currency: 'USD',
    isLoading: true,
  })

  useEffect(() => {
    const fetchRegion = async () => {
      // Check cache first
      const cached = localStorage.getItem('user_region')
      if (cached) {
        try {
          const parsed = JSON.parse(cached)
          setRegion({ ...parsed, isLoading: false })
          return
        } catch (e) {
          console.error('Error parsing cached region', e)
        }
      }

      try {
        const response = await fetch('https://ipapi.co/json/')
        if (!response.ok) throw new Error('IP API failed')

        const data = await response.json()
        const newRegion = {
          countryCode: data.country_code || 'US',
          currency: data.currency || 'USD',
          isLoading: false,
        }

        localStorage.setItem('user_region', JSON.stringify(newRegion))
        setRegion(newRegion)
      } catch (error) {
        console.error('Error fetching user region:', error)
        // Fallback is already set in initial state, just update loading
        setRegion((prev) => ({ ...prev, isLoading: false }))
      }
    }

    fetchRegion()
  }, [])

  return region
}
